import { useDispatch, useSelector } from 'react-redux';

import { formatNumber } from '@makemydeal/dr-common-utils';
import * as baseDealActionCreators from '@makemydeal/dr-dash-store/actions/baseDealActionCreators';
import * as interactionAnalyticsActionCreators from '@makemydeal/dr-dash-store/actions/interactionAnalyticsActionCreators';
import * as configSelectors from '@makemydeal/dr-dash-store/selectors/config';
import * as dealershipsSelectors from '@makemydeal/dr-dash-store/selectors/dealershipsSelectors';
import * as dealScreenErrorSelectors from '@makemydeal/dr-dash-store/selectors/dealScreenErrorSelectors';
import * as vehicleSelectors from '@makemydeal/dr-dash-store/selectors/vehicleSelectors';
import { joinNonEmptyStringParts } from '@makemydeal/dr-dash-ui-utils';
import { dealerSelectors, featureToggleSelectors } from '@makemydeal/dr-shared-store';
import { VEHICLE_ENTITY } from '@makemydeal/dr-shared-types';

export const CUSTOM_VEHICLE_LABEL = 'Custom Vehicle';

export const useVehicleInfo = () => {
    const dispatch = useDispatch();

    const { condition, make, model, stockNumber, trim, vin, year, isCustom, mileage, imageUrl } = useSelector(
        vehicleSelectors.getVehicle
    );
    const vAutoUrl = useSelector(configSelectors.getVAutoInventoryUrl);
    const isSwitchVehicleEnabled = useSelector(dealerSelectors.isSwitchVehicleEnabled);
    const isHideChangeVehicleNoDealerships = useSelector(featureToggleSelectors.isHideChangeVehicleNoDealershipsEnabled);
    const dealerships = useSelector(dealershipsSelectors.getDealerships);
    const hasVehicle = useSelector(vehicleSelectors.getHasVehicle);
    const hasMissingVehicleError = useSelector(dealScreenErrorSelectors.getFieldValidationError(VEHICLE_ENTITY, 'hasVehicle'));
    const isDealerAISearchEnabled = useSelector(dealerSelectors.isDealerAISearchEnabled);

    const shouldHideChangeVehicle = isHideChangeVehicleNoDealerships && dealerships.length === 0;

    const changeVehicle = () => {
        dispatch(interactionAnalyticsActionCreators.mvChangeVehicle());
        dispatch(baseDealActionCreators.openSlideOut(baseDealActionCreators.SlideOutType.ChangeVehicle));
    };

    const openInVAuto = () => {
        window.open(`${vAutoUrl}&vin=${vin}`, '_blank', 'noopener,noreferrer');
        dispatch(interactionAnalyticsActionCreators.viewInVautoLink());
    };

    return {
        title: joinNonEmptyStringParts(condition, year, make, model, trim),
        vin,
        stockNumber,
        stockLabel: `Stock #${stockNumber}`,
        mileage,
        mileageLabel: `${formatNumber(mileage)}mi`,
        isCustom,
        imageUrl,
        hasVehicle,
        hasMissingVehicleError,
        isDealerAISearchEnabled,
        isShowVehicleSelection: !hasVehicle || (isSwitchVehicleEnabled && !shouldHideChangeVehicle),
        changeVehicleLabel: hasVehicle ? 'Change Vehicle' : 'Add Vehicle',
        changeVehicle,
        hasVAuto: Boolean(vAutoUrl),
        openInVAuto
    };
};
